import {
    Dialog,
    DialogContent,
    IconButton,
    SxProps
} from "@mui/material";

import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ImageCarousel } from "./ImageCarousel";
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { ResolvedImageEntity } from "../../../lib/dashboard/types/ImageEntity";
import { SwiperClass } from "swiper/react";
import { grey } from "@mui/material/colors";
import { isMobile } from "react-device-detect";
import { useState } from "react";

type ExpandableThumbnailProps = {
    images: Array<ResolvedImageEntity> | undefined;
    thumbnailSxProps?: SxProps;
};

export const ExpandableThumbnail = ({ images, thumbnailSxProps }: ExpandableThumbnailProps) => {
    const [expanded, setExpanded] = useState(false);
    const [swiper, setSwiper] = useState<SwiperClass>();

    return (
        !images || images.length === 0 ? (
            <Box
                width={60}
                height={60}
                borderRadius={2}
                bgcolor={grey[50]}
                border={theme => `1px solid ${theme.palette.divider}`}
                display="flex"
                justifyContent="center"
                alignItems="center"
                color="text.secondary"
                sx={thumbnailSxProps}
            >
                <ImageOutlinedIcon />
            </Box>
        ) : (
            <>
                <Box
                    component="img"
                    src={images[0].urls.original}
                    srcSet={images[0].urls.thumbnail && `${images[0].urls.thumbnail}`}
                    onClick={() => setExpanded(true)}
                    width={60}
                    height={60}
                    borderRadius={2}
                    sx={{
                        objectFit: 'cover',
                        ...thumbnailSxProps
                    }}
                />
                <Dialog
                    onClose={() => setExpanded(false)}
                    open={expanded}
                    maxWidth="xl"
                    PaperProps={{
                        sx: {
                            height: "100%",
                            padding: 0,
                            display: !expanded ? "none" : undefined
                        }
                    }}
                    fullWidth
                    fullScreen={isMobile}
                >
                    <DialogContent
                        sx={{
                            p: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            "& img": {
                                objectFit: 'contain',
                            }
                        }}
                    >
                        <IconButton
                            onClick={(e) => setExpanded(false)}
                            sx={{
                                position: 'absolute',
                                right: 16,
                                top: 8,
                                color: grey[500],
                                zIndex: theme => theme.zIndex.tooltip
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <ImageCarousel
                            key="fullScreen"
                            images={images}
                            zoom={true}
                            objectFit="contain"
                            onSwiper={setSwiper}
                            swiper={swiper}
                            variant="full"
                        />
                    </DialogContent>
                </Dialog>
            </>
        )
    );
};